import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import Axios from "axios";

import { useStyles } from "./TimeTable.css";
import { url } from "../../../../Config/Config";
import AdminHeader from "../../../../Components/NavBar/Admin/AdminHeader/AdminHeader";
import CustomEmptyMessage from "../../../../Components/CustomEmptyMessage/CustomEmptyMessage";
import { week } from "../../../../Components/Data/Weeks";
import WeekTab from "./AddTimeTable/WeekTab/WeekTab";
import TimeTableFormFilter from "../TimeTableFormFilter/TimeTableFormFilter";
import { getAdminRefreshToken } from "../../../../Redux/Actions/actions";
import PageTitle from "../../../../Components/PageTitle/PageTitle";
import CustomBreadCrumbs from "../../../../Components/CustomBreadCrumbs/CustomBreadCrumbs";

class TimeTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        class: "",
        faculty: "",
        group: "",
        section: "",
      },
      timeList: {},
      subjectList: [],
      isData: false,
      isEmpty: true,
      loading: false,
    };
  }

  getTimeTable = async (configData) => {
    try {
      const getResponse = await Axios.get(`${url}/api/time-tables`, {
        params: {
          studentClass: configData.class,
          faculty: configData.faculty ? configData.faculty : null,
          group: configData.group ? configData.group : null,
          section: configData.section,
        },
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      if (getResponse.data.timeTables.length !== 0) {
        this.setState({
          isEmpty: false,
          timeList: getResponse.data.timeTables[0],
          subjectList: getResponse.data.timeTables[0].times,
          loading: false,
        });
        return true;
      } else {
        this.setState({
          isEmpty: true,
          timeList: {},
          subjectList: [],
          loading: false,
        });
        return false;
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.getTimeTable(configData);
      }
    }
  };

  handleChange = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        [e.target.name]: e.target.value,
      },
    });
  };

  handleChangeClass = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        class: e.target.value,
        faculty: "",
        group: "",
        section: "",
      },
    });
  };

  filterData = (data) => {
    let changedData = data;
    if (data.faculty === "") {
      delete changedData.faculty;
    }
    if (data.group === "") {
      delete changedData.group;
    }
    return changedData;
  };

  handleSubmit = async (e, subjectData) => {
    e.preventDefault();
    try {
      this.setState({ loading: true });
      let existStatus = await this.getTimeTable(this.state.data);
      console.log(existStatus);
      if (existStatus === false) {
        let subjectTimeTable = [];
        let subjects = [];
        let timetable = {};
        if (subjectData.length !== 0) {
          for (let i = 0; i <= subjectData.length - 1; i++) {
            subjects.push({
              subjectName: subjectData[i].name,
              from: "",
              to: "",
              classTeacherName: "",
              classTeacherId: "",
            });
          }
          for (let i = 0; i <= week.length - 1; i++) {
            subjectTimeTable.push({
              weekName: week[i],
              subjects: subjects,
            });
          }
          timetable = {
            studentClass: this.state.data.class,
            faculty: this.state.data.faculty ? this.state.data.faculty : "",
            group: this.state.data.group ? this.state.data.group : "",
            section: this.state.data.section,
            times: subjectTimeTable,
          };
        }
        let changedData = this.filterData(timetable);
        const response = await Axios.post(
          `${url}/api/time-tables`,
          changedData,
          {
            headers: {
              Authorization: `Bearer ${this.props.adminToken}`,
            },
          }
        );
        if (response.data.timeTable) {
          this.setState({
            isEmpty: false,
            timeList: response.data.timeTable,
            subjectList: response.data.timeTable.times,
            loading: false,
          });
        }
      }
    } catch (error) {
      this.setState({ loading: false });
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.handleSubmit(e);
      }
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <AdminHeader />
        <div className={classes.content}>
          <div className={classes.toolbar} />

          <CustomBreadCrumbs url={this.props.match.url} />
          <PageTitle
            title="Manage TimeTable"
            refreshUrl={this.props.match.url}
          />
          <TimeTableFormFilter
            loading={this.state.loading}
            buttonLabel="Get Time Table"
            data={this.state.data}
            handleChangeClass={this.handleChangeClass}
            handleChange={this.handleChange}
            handleSubmit={this.handleSubmit}
          />
          {this.state.isEmpty === false ? (
            this.state.subjectList && (
              <WeekTab
                timeList={this.state.timeList}
                subjectList={this.state.subjectList}
                config={this.state.data}
                getTimeTable={this.getTimeTable}
              />
            )
          ) : (
            <CustomEmptyMessage description="Please fill above form to set the timetables" />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    isAdmin: state.AdminReducer.isAdmin,
    role: state.AdminReducer.role,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(TimeTable)));
